SwitchDirective.$inject = [];
function SwitchDirective() {
    return {
        require: 'ngModel',
        restrict: 'E',
        scope: {},
        template: require('./views/switch.html'),
        link: function (scope, element, attrs, ngModel) {
            var updateModel = function () {
                scope.model = ngModel.$viewValue;
            };
            scope.toggle = function () {
                ngModel.$setViewValue(!ngModel.$viewValue);
                updateModel();
            };
            ngModel.$render = function () {
                updateModel();
            };
        }
    };
}
angular.module('rinca.core.directives.switch', [])
    .directive('switch', SwitchDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/SwitchDirective.ts
// module id = 305
// module chunks = 0